export default __webpack_public_path__ + "static/ico-planeta-3d33d1ac8998c54707c5bb36e12b3b3e.svg";